import { TERRITORY_FILTER_LIMIT } from '@/models/filter/filterDefaultLimits';
import { isNonEmptyStringArray } from '@/models/filter/utils/isNonEmptyStringArray';
import { GetOptionsQueryFunction } from '@/types/cube/query';
import { FilterConfigDynamic } from '@/types/filter/filterConfig';
import { toStringOrNull } from '@/utils/cube/mapper';

import { buildSubnationalSalesPeriodFilters, SUBNATIONAL_SALES_CUBE_NAME } from './subnationalSalesOptionsQuery';

const DIMENSION = `${SUBNATIONAL_SALES_CUBE_NAME}.territory_level_1_name`;
const COUNTRY_NAME = `${SUBNATIONAL_SALES_CUBE_NAME}.country_name`;

const SALES_TERRITORY_OPTIONS: GetOptionsQueryFunction = ({ dateRange, comparisonPeriod }) => ({
  dimensions: [DIMENSION, COUNTRY_NAME],
  filters: buildSubnationalSalesPeriodFilters([dateRange, comparisonPeriod]),
  order: { [DIMENSION]: 'asc' },
  limit: TERRITORY_FILTER_LIMIT,
});

const salesTerritoryFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.salesTerritoryLabel',
  placeholder: 'global.filters.formControls.salesTerritoryLabel',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  sourceCube: SUBNATIONAL_SALES_CUBE_NAME,
  getOptionsQuery: SALES_TERRITORY_OPTIONS,
  mapResult: cubeRow => {
    const value = toStringOrNull(cubeRow[DIMENSION]);
    if (!value) return null;
    return { value, label: value, category: toStringOrNull(cubeRow[COUNTRY_NAME]) ?? undefined };
  },
  applyFilter: value => {
    if (!isNonEmptyStringArray(value)) return undefined;
    return { member: DIMENSION, operator: 'equals', values: value };
  },
};

export default salesTerritoryFilter;
